import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { offlineDotStyles, onlineDotStyles } from './TeamChatPresenceIndicator.styles';

const TeamChatPresenceIndicator = memo(({ isOnline = false }) => (
  <Box sx={isOnline ? onlineDotStyles : offlineDotStyles} />
));
TeamChatPresenceIndicator.propTypes = {
  isOnline: PropTypes.bool,
};

export default TeamChatPresenceIndicator;
